import apiClient from 'utilities/apiClient';

export const signin = (payload) => {
  return apiClient.post(`${apiClient.Urls.signin}`, payload);
};
// app_logout
export const app_logout = (payload) => {
  return apiClient.get(`${apiClient.Urls.logout}`, payload, 'true');
};
// generate_otp
export const generate_otp = (payload) => {
  return apiClient.post(`${apiClient.Urls.otp}`, payload);
};
